import '../../styles/Security/Account.css';

import React                   from 'react';
import Row                     from 'components/App/Row';
import { Col }                 from 'antd';
import { observer }            from 'mobx-react';
import { reaction }            from 'mobx';
import { appStore }            from 'stores/AppStore';
import currentSession          from 'utils/currentSession';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import { getLabel }            from 'constants/Languages';
import GridInfo                from 'components/App/GridInfo';
import CardBox                 from 'components/App/CardBox';
import DropDownMenu            from 'components/App/DropDownMenu';
import { AppForm }             from 'components/App/AppForm';
import { messageSuccessIntl }  from 'utils/messageIntl';
import AccountForm             from 'forms/AccountForm';
import PageTitle               from 'components/App/PageTitle';
import UserModel               from 'models/UserModel';

@observer
class Account extends React.Component {
  public reaction: any;
  public user = new UserModel();

  public componentDidMount() {
    this.user.set('id', currentSession.user.user_id);
    this.user.fetch();

    this.reaction = reaction(
      () => currentSession.user,
      () => {
        this.user.fetch();
      },
    );
  }

  public componentWillUnmount() {
    this.reaction = undefined;
  }

  public render() {
    const data = [
      [
        {
          label: <FormattedMessageWrapper id="Identifiant" />,
          value: this.user.email || this.user.username,
        },
        {
          label: <FormattedMessageWrapper id="Prénom" />,
          value: this.user.firstName,
        },
        {
          label: <FormattedMessageWrapper id="Nom" />,
          value: this.user.lastName,
        },
        {
          label: <FormattedMessageWrapper id="Préférence linguistique" />,
          value: getLabel(this.user.languagePreference),
        },
      ],
    ];

    const items = [
      {
        key: 'OPEN_ACCOUNT_FORM_MODAL',
        label: <FormattedMessageWrapper id="Modifier mes informations" />,
        onClick: () => {
          AppForm.open(AccountForm, {
            model: this.user,
            onSuccess: async () => {
              messageSuccessIntl("Modification réussie !");

              await currentSession.refresh();

              appStore.switchLanguage(this.user.languagePreference);
            },
          }, {
            okText: <FormattedMessageWrapper id="Enregistrer" />,
            title: <FormattedMessageWrapper id="Modifer mes informations" />,
          });
        },
      },
    ];

    return (
      <>
        <PageTitle title={<FormattedMessageWrapper id="Mon compte" />} />

        <CardBox
          content={
            <>
              <Row>
                <Col lg={6} md={12} sm={24}>
                  <GridInfo
                    data={data}
                    gridStyle={{ minWidth: 512 }}
                  />
                </Col>
              </Row>
            </>
          }
          extra={<DropDownMenu items={items} />}
          loading={this.user.isLoading}
          title={<FormattedMessageWrapper id="Informations" />}
        />
      </>
    );
  }

}

export default Account;
